import api from './index'
import { axios } from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function userLogin(parameter) {
  return axios({
    url: api.UserLogin,
    method: 'post',
    data: parameter
  })
}

export function userLogout(parameter) {
  return axios({
    url: api.UserLogout,
    method: 'post',
    data: parameter
  })
}

export function userGetInfo() {
  return axios({
    url: api.userGetInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
